import { css } from "@vitality-ds/system";
export default css({
  display: "flex",
  flexWrap: "wrap",
  alignContent: "center",
  flexGrow: 1
});